<template>
  <div class="info-table-base">
    <table>
      <tr class="table-header-tr">
        <td><div class="table-header">地块名称</div></td>
        <td><div class="table-header">地块类型</div></td>
        <td><div class="table-header">地块面积</div></td>
        <td><div class="table-header">地块位置</div></td>
        <!-- <td><div class="table-header">容积率</div></td> -->
      </tr>
      <tr
        v-for="(item, index) in tableList"
        :key="index"
        v-show="tableList.length"
        @click="
          $router.push({
            path: '/land/detail',
            query: { id: item.id },
          })
        "
      >
        <td>{{ item.name || item.code }}</td>
        <td>{{ item.typeName }}</td>
        <td>{{ item.area }}亩</td>
        <td>{{ item.countyName }}</td>
        <!-- <td>{{ item.plotRate ? item.plotRate : "--" }}</td> -->
      </tr>
      <tr v-show="!tableList.length">
        <td colspan="5">暂无数据</td>
      </tr>
    </table>
    <div>
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        :current-page="search.current"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { landList, getParcelIndex } from "@/api/setting/investment";
export default {
  name: "infoTable",
  props: {
    landType: {
      type: String,
      default() {
        // 分为  已交易、未交易 || 商服 住宅 工矿 其他
        return "";
      },
    },
    searchLand: {
      type: Object,
      default() {
        return {
          type: "",
          size: 10,
          current: 1,
          transaction: "",
          supplyPeriod: "",
          approvalStatus: "",
          county: "",
        };
      },
    },
  },
  watch: {
    searchLand: {
      deep: true,
      handler(val) {
        this.search = val;
        this.getList();
      },
    },
  },
  data() {
    return {
      search: {},
      total: 0,
      tableList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  mounted() {
    this.search = this.searchLand;
    this.getList();
  },
  methods: {
    async getList() {
      let { data: res } = await getParcelIndex(this.search);
      if (res.success) {
        this.tableList = res.data.records;
        this.total = res.data.total;
      }
    },
    //切换页码
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },

    //切换页条数
    handleSizeChange(val) {
      this.search.size = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
.info-table-base {
}
.info-table-base table {
  width: 100%;
  border-spacing: unset;
}
.info-table-base table tr td {
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}
.info-table-base table tr:hover {
  cursor: pointer;
  background: #f3f9fc;
}
.table-header-tr {
  background: #f3f9fc;
}
.table-header-tr td {
  font-size: 0.95rem;
  font-weight: bold;
}
.table-header {
  color: #3f8acc;
  padding: 5px;
}
</style>
